import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { AdminIndicacionAll } from './components/AdminIndicacionAll';

export default function AdminIndicacion() {
  return (
    <>
      <MainContent
        titulo='Administración de Indicaciones'
        component={<AdminIndicacionAll />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}